<!-- song history configuration page -->
<rk-page-configuration-container>
  <div content>
    <rk-setting-divider></rk-setting-divider>
    <div class="p-6 flex flex-col gap-8">
      <!-- loop through all streams -->
      @for (stream of streams; track stream.idflux) {
        <div class="flex flex-col gap-1">
          <!-- stream header with name and toggle -->
          <div class="flex items-center w-full justify-between">
            <p class="font-bold">
              {{ stream.nomFlux }}
            </p>
            <rk-switch
              [isChecked]="stream.ckoiConfiguration?.active ?? false"
              (switched)="onConfigToggleChanged(stream.idflux, 'active')"
            ></rk-switch>
          </div>
          <!-- configuration fields (shown when active) -->
          @if (stream.ckoiConfiguration?.active) {
            <div class="flex flex-col gap-6">
              <!-- api url field -->
              <div class="flex flex-col">
                <p class="font-medium">
                  {{ 'song-history-config.api-url' | translate }}
                </p>
                <p class="opacity-70 mb-4">
                  {{ 'song-history-config.api-url-description' | translate }}
                </p>
                <rk-form-field class="relative" [showError]="!isValidUrl(stream.ckoiConfiguration?.apiUrl ?? '')">
                  <input
                    class="truncate"
                    [placeholder]="'https://monapi.com'"
                    [value]="stream.ckoiConfiguration?.apiUrl ?? ''"
                    (input)="onApiUrlChanged($event, stream.idflux)"
                  />
                  @if (!isValidUrl(stream.ckoiConfiguration?.apiUrl ?? '')) {
                    <div class="form-error-message absolute left-0 top-full">
                      {{ 'global.url-invalid' | translate }}
                    </div>
                  }
                </rk-form-field>
              </div>

              @if (stream.ckoiConfiguration?.searchOptionAvailable) {
                <!-- search api url field -->
                <div class="flex flex-col">
                  <p class="font-medium">
                    {{ 'song-history-config.search-api-url' | translate }}
                  </p>
                  <p class="opacity-70 mb-4">
                    {{ 'song-history-config.search-api-url-description' | translate }}
                  </p>
                  <rk-form-field class="relative" [showError]="!isValidUrl(stream.ckoiConfiguration?.searchApiUrl ?? '')">
                    <input
                      [placeholder]="'https://monapi.com/search'"
                      class="truncate"
                      [value]="stream.ckoiConfiguration?.searchApiUrl ?? ''"
                      (input)="onSearchApiUrlChanged($event, stream.idflux)"
                    />
                    @if (!isValidUrl(stream.ckoiConfiguration?.searchApiUrl ?? '')) {
                      <div class="form-error-message absolute left-0 top-full">
                        {{ 'global.url-invalid' | translate }}
                      </div>
                    }
                  </rk-form-field>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</rk-page-configuration-container>
